import React, { useContext } from "react";
import {
  useRouteError,
  isRouteErrorResponse,
} from "react-router-dom";
import { NotFoundStyled } from "./NotFoundStyled";
import { getValueForKey } from "../../context/translationsUtils";
import { TranslationContext } from "../../context/TranslationContext";
import { TranslationContextInterface } from "../../entities/Language";
import { RouterErrorInterface } from "../../entities/Common";

interface ErrorData {
  message: string;
  link?: string; // Add link property
  [key: string]: any; // Allow other properties as well
}

const NotFound: React.FC = () => {
  const { translations }: TranslationContextInterface =
    useContext(TranslationContext);
  const error = useRouteError() as
    | RouterErrorInterface
    | undefined
    | Response;
  return (
    <NotFoundStyled>
      {isRouteErrorResponse(error) ? (
        <>
          {typeof error.data === "object" && error.data !== null && "message" in error.data && "link" in error.data ? (
            <h2>
              {(error.data as ErrorData).message} -
              <a href={(error.data as ErrorData).link}>{(error.data as ErrorData).link}</a>
            </h2>
          ) : (
            <h2>{error.data}</h2>
          )}
        </>
      ) : (
        <h2>{getValueForKey(translations, "nav_bar.no_route_found")}</h2>
      )}
    </NotFoundStyled>
  );
};

export default NotFound;
